import type {MouseEventHandler} from 'react';

export type FixButtonVariant = 'primary' | 'secondary';

export const FIX_THIS_ICON = 'icon-refresh';

export interface FixThisButtonProps {
  onClick: MouseEventHandler;
  isLoading: boolean;
  disabled: boolean;
  variant?: FixButtonVariant;
  isFullWidth?: boolean;
  isCompact?: boolean;
  customClasses?: string;
}
